/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

jQuery(document).ready(function( $ ) {
    $("#mobile-menu").mmenu({

  });
});

jQuery(function() {
  function reposition() {
    var modal = jQuery(this),
    dialog = modal.find('.modal-dialog');
    modal.css('display', 'block');

    // Dividing by two centers the modal exactly, but dividing by three
    // or four works better for larger screens.
    dialog.css("margin-top", Math.max(0, (jQuery(window).height() - dialog.height()) / 2));
  }
  // Reposition when a modal is shown
  jQuery('.modal').on('show.bs.modal', reposition);
  // Reposition when the window is resized
  jQuery(window).on('resize', function() {
    jQuery('.modal:visible').each(reposition);
  });
  if(isSRSupported()){
    window.sr = ScrollReveal();
    sr.reveal('.row-bg',  { duration: 600, delay: 1, scale:1, distance: '200px', viewFactor: 0.5});
  }
    jQuery('.modal').appendTo(document.body);
});


/**
 * Check if client supports CSS Transform and CSS Transition.
 * @return {boolean}
 */
isSRSupported = function () {
  var style = document.documentElement.style
  return 'WebkitTransition' in style && 'WebkitTransform' in style
      || 'transition' in style && 'transform' in style
}

jQuery(function() {
  jQuery('.content-with-image').matchHeight();
  var mySVGsToInject = jQuery('img.svg-inject');
  SVGInjector(mySVGsToInject);
});

/*!
 * vimeo.ga.js | v0.6
 * Based on modifications by LukasBeaton (https://github.com/LukasBeaton/vimeo.ga.js)
 * Copyright (c) 2015 Sander Heilbron (http://www.sanderheilbron.nl)
 * MIT licensed
 */


var vimeoGAJS = (window.vimeoGAJS) ? window.vimeoGAJS : {};

(function($) {
  vimeoGAJS = {
    iframes : [],
    gaTracker : undefined,
    eventMarker : {},

    init: function () {
      vimeoGAJS.iframes = $('iframe');

      $.each(vimeoGAJS.iframes, function (index, iframe) {
        var iframeId = $(iframe).attr('id');

        vimeoGAJS.eventMarker[iframeId] = {
          'progress25' : false,
          'progress50' : false,
          'progress75' : false,
          'videoPlayed' : false,
          'videoPaused' : false,
          'videoResumed' : false,
          'videoSeeking' : false,
          'videoCompleted' : false,
          'timePercentComplete' : 0
        };
      });

      // Check which version of Google Analytics is used
      if (typeof ga === "function") {
        vimeoGAJS.gaTracker = 'ua'; // Universal Analytics (universal.js)
        //console.info('Universal Analytics');
      }

      if (typeof _gaq !== "undefined" && typeof _gaq.push === "function") {
        vimeoGAJS.gaTracker = 'ga'; // Classic Analytics (ga.js)
        //console.info('Classic Analytics');
      }

      if (typeof dataLayer !== "undefined" && typeof dataLayer.push === "function") {
        vimeoGAJS.gaTracker = 'gtm'; // Google Tag Manager (dataLayer)
        //console.info('Google Tag Manager');
      }

      // Listen for messages from the player
      if (window.addEventListener) {
        window.addEventListener('message', vimeoGAJS.onMessageReceived, false);
      } else {
        window.attachEvent('onmessage', vimeoGAJS.onMessageReceived, false);
      }
    },

    // Handle messages received from the player
    onMessageReceived: function(e) {
      if (e.origin.replace('https:', 'http:') !== "http://player.vimeo.com" || typeof vimeoGAJS.gaTracker === 'undefined') {
        //console.warn('Tracker is missing!');
        return;
      }

      var data = JSON.parse(e.data),
          iframeEl = $("#"+data.player_id),
          iframeId = iframeEl.attr('id');

      switch (data.event) {
        case 'ready':
          vimeoGAJS.onReady();
          break;

        case 'playProgress':
          vimeoGAJS.onPlayProgress(data.data, iframeEl);
          break;

        case 'seek':
          if (iframeEl.data('seek') && !vimeoGAJS.eventMarker[iframeId].videoSeeking) {
            vimeoGAJS.sendEvent(iframeEl, 'Skipped video forward or backward');
            vimeoGAJS.eventMarker[iframeId].videoSeeking = true; // Avoid subsequent seek trackings
          }
          break;

        case 'play':
          if (!vimeoGAJS.eventMarker[iframeId].videoPlayed) {
            vimeoGAJS.sendEvent(iframeEl, 'Started video');
            vimeoGAJS.eventMarker[iframeId].videoPlayed = true; // Avoid subsequent play trackings
          } else if (!vimeoGAJS.eventMarker[iframeId].videoResumed && vimeoGAJS.eventMarker[iframeId].videoPaused) {
            vimeoGAJS.sendEvent(iframeEl, 'Resumed video');
            vimeoGAJS.eventMarker[iframeId].videoResumed = true; // Avoid subsequent resume trackings
          }
          break;

        case 'pause':
          vimeoGAJS.onPause(iframeEl);
          break;

        case 'finish':
          if (!vimeoGAJS.eventMarker[iframeId].videoCompleted) {
            vimeoGAJS.sendEvent(iframeEl, 'Completed video');
            vimeoGAJS.eventMarker[iframeId].videoCompleted = true; // Avoid subsequent finish trackings
          }
          //back to start screen for homepage video
          if(iframeId == "home-video"){
            jQuery(".homepage-video .inner").show();
            jQuery(".homepage-video .vimeo-wrapper").hide();
          }

          break;
      }
    },

    getLabel : function(iframeEl) {
      var iframeSrc = iframeEl.attr('src').split('?')[0];
      var label = iframeSrc;
      if (iframeEl.data('title')) {
        label += ' (' + iframeEl.data('title') + ')';
      } else if (iframeEl.attr('title')) {
        label += ' (' + iframeEl.attr('title') + ')';
      }
      return label;
    },

    // Helper function for sending a message to the player
    post : function (action, value, iframe) {
      var data = {
        method: action
      };

      if (value) {
        data.value = value;
      }

      // Source URL
      var iframeSrc = $(iframe).attr('src').split('?')[0];

      iframe.contentWindow.postMessage(JSON.stringify(data), iframeSrc);
    },

    onReady :function() {
      $.each(vimeoGAJS.iframes, function(index, iframe) {
        vimeoGAJS.post('addEventListener', 'play', iframe);
        vimeoGAJS.post('addEventListener', 'seek', iframe);
        vimeoGAJS.post('addEventListener', 'pause', iframe);
        vimeoGAJS.post('addEventListener', 'finish', iframe);
        vimeoGAJS.post('addEventListener', 'playProgress', iframe);
      });
    },

    onPause: function(iframeEl) {
      var iframeId = iframeEl.attr('id');
      if (vimeoGAJS.eventMarker[iframeId].timePercentComplete < 99 && !vimeoGAJS.eventMarker[iframeId].videoPaused) {
        vimeoGAJS.sendEvent(iframeEl, 'Paused video');
        vimeoGAJS.eventMarker[iframeId].videoPaused = true; // Avoid subsequent pause trackings
      }
    },

    // Tracking video progress
    onPlayProgress: function(data, iframeEl) {
      var progress,
          iframeId = iframeEl.attr('id');
      vimeoGAJS.eventMarker[iframeId].timePercentComplete = Math.round((data.percent) * 100); // Round to a whole number

      if (!iframeEl.data('progress')) {
        return;
      }

      if (vimeoGAJS.eventMarker[iframeId].timePercentComplete > 24 && !vimeoGAJS.eventMarker[iframeId].progress25) {
        progress = 'Played video: 25%';
        vimeoGAJS.eventMarker[iframeId].progress25 = true;
      }

      if (vimeoGAJS.eventMarker[iframeId].timePercentComplete > 49 && !vimeoGAJS.eventMarker[iframeId].progress50) {
        progress = 'Played video: 50%';
        vimeoGAJS.eventMarker[iframeId].progress50 = true;
      }

      if (vimeoGAJS.eventMarker[iframeId].timePercentComplete > 74 && !vimeoGAJS.eventMarker[iframeId].progress75) {
        progress = 'Played video: 75%';
        vimeoGAJS.eventMarker[iframeId].progress75 = true;
      }

      if (progress) {
        vimeoGAJS.sendEvent(iframeEl, progress);
      }
    },

    // Send event to Classic Analytics, Universal Analytics or Google Tag Manager
    sendEvent: function (iframeEl, action) {

      var bounce = iframeEl.data('bounce');
      var label = vimeoGAJS.getLabel(iframeEl);

      switch (vimeoGAJS.gaTracker) {
        case 'gtm':
          dataLayer.push({'event': 'Vimeo', 'eventCategory': 'Vimeo', 'eventAction': action, 'eventLabel': label, 'eventValue': undefined, 'eventNonInteraction': (bounce) ? false : true });
          break;

        case 'ua':
          ga('send', 'event', 'Vimeo', action, label, undefined, {'nonInteraction': (bounce) ? 0 : 1});
          break;

        case 'ga':
          _gaq.push(['_trackEvent', 'Vimeo', action, label, undefined, (bounce) ? false : true]);
          break;
      }
    }
  };

  vimeoGAJS.init();
})(jQuery);


(function ($)
{
  $.utils = {
    // http://stackoverflow.com/a/8809472
    createUUID: function ()
    {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function")
      {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c)
      {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    }
  }

  $.fn.dialogue = function (options)
  {
    var defaults = {
      title: "", content: $("<p />"),
      closeIcon: false, id: $.utils.createUUID(), open: function () { }, buttons: []
    };
    var settings = $.extend(true, {}, defaults, options);

    // create the DOM structure
    var $modal = $("<div />").attr("id", settings.id).attr("role", "dialog").addClass("modal fade")
        .append($("<div />").addClass("modal-dialog")
            .append($("<div />").addClass("modal-content")
                .append($("<div />").addClass("modal-header")
                    .append($("<h3 />").addClass("modal-title").text(settings.title)))
                .append($("<div />").addClass("modal-body")
                    .append(settings.content))
                .append($("<div />").addClass("modal-footer")
                )
            )
        );
    $modal.shown = false;
    $modal.dismiss = function ()
    {
      // loop until its shown
      // this is only because you can do $.fn.alert("utils.js makes this so easy!").dismiss(); in which case it will try to remove it before its finished rendering
      if (!$modal.shown)
      {
        window.setTimeout(function ()
        {
          $modal.dismiss();
        }, 50);
        return;
      }

      // hide the dialogue
      $modal.modal("hide");
      // remove the blanking
      $modal.prev().remove();
      // remove the dialogue
      $modal.empty().remove();

      $("body").removeClass("modal-open");
    }

    if (settings.closeIcon)
      $modal.find(".modal-header").prepend($("<button />").attr("type", "button").addClass("close").html("&times;").click(function () { $modal.dismiss() }));

    // add the buttons
    var $footer = $modal.find(".modal-footer");
    for(var i=0; i < settings.buttons.length; i++)
    {
      (function (btn)
      {
        $footer.prepend($("<button />").addClass("btn btn-primary")
            .attr("id", btn.id)
            .attr("type", "button")
            .text(btn.text)
            .click(function ()
            {
              btn.click($modal)
            }))
      })(settings.buttons[i]);
    }
    var modal = $modal, dialog = modal.find('.modal-dialog');
    modal.css('display', 'block');
    // Dividing by two centers the modal exactly, but dividing by three
    // or four works better for larger screens.
    dialog.css("margin-top", Math.max(0, (jQuery(window).height() - dialog.height()) / 2.5));
    settings.open($modal);

    $modal.on('shown.bs.modal', function (e) {
      $modal.shown = true;
    });
    // show the dialogue
    $modal.modal("show");

    return $modal;
  };
})(jQuery);

(function ($)
{
  $.fn.alert = function (word, message)
  {
    return $.fn.dialogue({
      title: word,
      content: $("<p />").text(message),
      closeIcon: true,
      buttons: [
        { text: "Close", id: $.utils.createUUID(), click: function ($modal) { $modal.dismiss(); } }
      ]
    });
  };

})(jQuery);


jQuery(".launch-glossary").click(function(e){
  e.preventDefault();
  jQuery.fn.alert(jQuery(this).data("word"), jQuery(this).data("definition"));
});
